/* eslint-disable max-len */
export const lightTheme = {
  skeleton: '#F0F0F0',
  transparent: 'transparent',
  body: '#EEEEEE',
  primary: '#6A49D9',
  secundary: '#06E4C0',
  support: '#FF5C76',
  white: '#FFFFFF',
  success: '#35E19D',
  green: '#06E4C0',
  warning: '#FFBF44',
  error: '#FF5858',
  purple: '#6A49D9',
  purpleLight: '#F1EDFC',
  purpleDark: '#4C2CBB',
  gray1: '#FCFCFF',
  gray2: '#EAECF3',
  gray3: '#DBDBEA',
  gray4: '#BDC1CB',
  gray5: '#7A7D8B',
  gray6: '#474747',
  gray7: '#2D2E34',
  gray8: '#0B0B0E',
  // Permanet Colos
  textWhite: '#000000',
  // Public Area
  linerGradientMain:
    'linear-gradient(159.96deg, #00dead -3.56%, rgba(40, 134, 176, 0.516258) 44.37%, rgba(255, 92, 118, 0.6) 95.51%)',
  boxShadowFocused: 'rgba(162, 135, 255, 0.42)',
  // Private Area
  backgroundPrivateLayout: '#eeeeee',
  // Route
  backgroundRoute: '#ffffff',
  titleRoute: '#474747',
  // SideBar
  gradientSidebar:
    'linear-gradient(159.96deg, #00dead -3.56%, rgba(40, 134, 176, 0.516258) 44.37%, rgba(255, 92, 118, 0.6) 95.51%), linear-gradient(0deg, #5329b4, #5329b4)',
  menuActiveBackground: 'rgba(255,255,255, 0.2)',
  itemMenuActive: '#ffffff',
  // Header
  backgroundHeader: '#ffffff',
  // Header - notification
  notificationBackground: '#F3F3F5',
  notificationIcon: '#6A49D9',
  // Header - profile
  profileName: '#7A7D8B',
  // Header - divider
  headerDivider: '#7A7D8B',
  // Components
  // Table
  tableBackgroud: '#ffffff',
  tableTextColor: '#7A7D8B',
  tableRowActive: '#BDC1CB',
  tableBoxShadow: '#F1F1F7',
  tableHR: '#EAECF3',
  tableColorRowNthChild: 'rgba(0,0,0,0.5)',
  // Table - Pagination
  paginationText: '#7A7D8B',
  // Table - Input Search
  inputSearchIcon: '#BDC1CB',
  inputSearchText: '#BDC1CB',
  buttonFilterText: '#7A7D8B',
  buttonFilterBorder: '#DBDBEA',
  // Checkbox
  checkboxBackground: '#ffffff',
  checkboxBorderColor: '#DBDBEA',
  // inputs
  inputColors: '#FFFFFF',
  inputText: { focus: '#6A49D9', normal: '#000000' }
};

export const darkTheme = {
  skeleton: '#4F515C',
  transparent: 'transparent',
  body: '#EEEEEE',
  primary: '#6A49D9',
  secundary: '#06E4C0',
  support: '#FF5C76',
  white: '#FFFFFF',
  success: '#35E19D',
  green: '#06E4C0',
  warning: '#FFBF44',
  error: '#FF5858',
  purple: '#6A49D9',
  purpleLight: '#F1EDFC',
  purpleDark: '#4C2CBB',
  gray1: '#FCFCFF',
  gray2: '#EAECF3',
  gray3: '#DBDBEA',
  gray4: '#BDC1CB',
  gray5: '#7A7D8B',
  gray6: '#474747',
  gray7: '#2D2E34',
  gray8: '#0B0B0E',
  // Permanet Colos
  textWhite: '#ffffff',
  // Public Area
  boxShadowFocused: 'rgba(162, 135, 255, 0.42)',
  linerGradientMain:
    'linear-gradient(159.96deg, #00dead -3.56%, rgba(40, 134, 176, 0.516258) 44.37%, rgba(255, 92, 118, 0.6) 95.51%)',
  // Private Area
  backgroundPrivateLayout: '#474747',
  // Route
  backgroundRoute: '#2D2E34',
  titleRoute: '#ffffff',
  // SideBar
  gradientSidebar: 'linear-gradient(180deg, #2D2E34 0%, #2D2E34 100%)',
  // menuActiveBackground: 'linear-gradient(98.13deg, #6A49D9 -33.04%, #FF5C76 28.25%, #2886B0 71.17%, #06E4C0 119.03%)',
  menuActiveBackground: 'rgba(255,255,255, 0.2)',
  itemMenuActive: '#ffffff',
  // Header
  backgroundHeader: 'linear-gradient(180deg, #2D2E34 0%, #2D2E34 100%)',
  // Header  - notification
  notificationBackground: '#37393e',
  notificationIcon: '#ffffff',
  // Header - profile
  profileName: '#ffffff',
  // Header - divider
  headerDivider: '#DBDBEA',
  // Components
  // Table
  tableBackgroud: '#2D2E34',
  tableTextColor: '#FCFCFF',
  tableRowActive: '#BDC1CB',
  tableBoxShadow: '#323232',
  tableHR: '#474747',
  tableColorRowNthChild: 'rgba(0,0,0,0.9)',
  // Table - Pagination
  paginationText: '#7A7D8B',
  // Table - Input Search
  inputSearchIcon: '#DBDBEA',
  inputSearchText: '#DBDBEA',
  buttonFilterText: '#DBDBEA',
  buttonFilterBorder: '#474747',
  // Checkbox
  checkboxBackground: '#474747',
  checkboxBorderColor: '#7A7D8B',
  // inputs
  inputColors: '#FFFFFF',
  inputText: { focus: '#6A49D9', normal: '#000000' }

};

export type Colors =
  | 'transparent'
  | 'textWhite'
  | 'itemMenuActive'
  | 'body'
  | 'primary'
  | 'secundary'
  | 'support'
  | 'white'
  | 'success'
  | 'warning'
  | 'purple'
  | 'purpleLight'
  | 'green'
  | 'purpleDark'
  | 'error'
  | 'gray1'
  | 'gray2'
  | 'gray3'
  | 'gray4'
  | 'gray5'
  | 'gray6';

export type Theme = typeof lightTheme;
